export function getAge(dateString) {
    if (!dateString || dateString === "Invalid date") return 0;
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export const getQuantity = (dosageStr, durationStr) => {
    const dosage = dosageStr
        .split("-")
        .reduce(
            (sum, part) =>
                sum +
                (part.includes("½")
                    ? parseFloat(part.replace("½", ".5"))
                    : parseFloat(part)),
            0
        );
    const match = durationStr.match(/(\d+)\s*(weeks|months|days)/);

    if (!match) return 0; // If no match, return 0

    const [_, num, unit] = match; // Destructure match array safely
    const duration =
        unit === "weeks"
            ? num * 7
            : unit === "months"
            ? num * 30
            : parseInt(num);

    return dosage * duration;
};

export function to12HourFormat(timeStr) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const suffix = hours >= 12 ? "PM" : "AM";
    const hour12 = hours % 12 || 12;
    return `${hour12}:${minutes.toString().padStart(2, "0")} ${suffix}`;
}
